module.exports = __webpack_public_path__ + "img/18_11.bb7268dc.png";